import { API_BASE_URL } from '../config/api'
import { getAuthHeaders } from '../utils/authUtils'

export type VerificationStatus = 'PENDING' | 'APPROVED' | 'REJECTED'

export interface BusinessVerification {
  id: string
  userId: string
  status: VerificationStatus
  organizationName: string
  website?: string | null
  ein?: string | null
  street: string
  city: string
  state: string
  zipCode: string
  submittedAt: string
  reviewedAt?: string | null
  reviewedById?: string | null
  rejectionReason?: string | null
}

export async function getMyBusinessVerificationStatus(): Promise<BusinessVerification | null> {
  const response = await fetch(`${API_BASE_URL}/api/business-verification/status`, {
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders()
    }
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || 'Failed to fetch business verification status')
  return data.data || null
}

export async function submitBusinessVerification(input: {
  organizationName: string
  website?: string
  ein?: string
  street: string
  city: string
  state: string
  zipCode: string
}): Promise<BusinessVerification> {
  const response = await fetch(`${API_BASE_URL}/api/business-verification/submit`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders()
    },
    body: JSON.stringify(input)
  })
  const data = await response.json()
  if (!response.ok) throw new Error(data.error || 'Failed to submit business verification')
  return data.data
}


